<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G.H. Raisoni Memorial Durg Divisional Chess Tournament 2026 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G.H. Raisoni Memorial Durg Divisional Chess Tournament 2026 </span></h2>
        </div>

        <p><strong>Date: </strong>May 5, 2026 </p>
        <p><strong>Venue: </strong>Saraswati Shishu Mandir, Khairagarh</p>
        <p><strong>Organized By: </strong>KCG District Chess Association</p>
        <p><strong>Under the Aegis of: </strong>Chhattisgarh Pradesh Shatranj Sangh</p>
        <p><strong>In Association with: </strong>Raisoni Foundation & Kalpana Prakash Welfare Foundation</p>
        <p><strong>Total Prize Fund: </strong>₹30,000</p>
        <h5 class="primary-purple">Introduction:</h5>
        <p> The G.H. Raisoni Memorial Durg Divisional Chess Tournament 2026, Khairagarh was successfully conducted on
            May 5,
            2026, at the campus of Saraswati Shishu Mandir, Khairagarh. Organized by the KCG District Chess Association,
            the
            prestigious event was held under the aegis of the Chhattisgarh Pradesh Shatranj Sangh and in association
            with
            the Raisoni Foundation & Kalpana Prakash Welfare Foundation. The tournament aimed to provide a competitive
            platform for the budding and experienced chess players of the Durg Division.</p>
        <p>Khairagarh is a remote and culturally rich area of Chhattisgarh. Historically, players from such regions have
            had limited exposure to structured competitive platforms. This tournament marks a historic milestone as the
            largest-scale chess tournament ever organized in Khairagarh. The primary objective of this grand initiative
            was
            to reach out to the remote corners of the division, scout raw rural talents, and provide them with a
            professional and standardized platform to showcase their strategic abilities.</p>
        <p> The grand event commenced with an auspicious inauguration ceremony. We were highly honored to have Mrs.
            Yashoda
            Verma (MLA, Khairagarh) as our esteemed Inauguration Chief Guest, whose encouraging words greatly inspired
            the
            players.</p>

        <p>The tournament saw excellent representation with participants from 7 districts/clubs:</p>
        <ul class="list-style list-style1 mb-3 list-count">
            <li>KCG (Khairagarh-Chhuikhadan-Gandai)</li>
            <li>Durg</li>
            <li>Kabirdham</li>
            <li>Rajnandgaon</li>
            <li>Bemetara</li>
            <li>Balod</li>
            <li>MMAC (Mohla-Manpur-Ambagarh Chowki)</li>
        </ul>
        <p>A total of 68 players participated in this competitive event, showcasing excellent talent. The participation
            included a diverse group of 51 boys and 17 girls, competing across multiple categories.</p>
        <h5 class="primary-purple"> Technical Administration & Regulations</h5>
        <p>The tournament was conducted strictly in accordance with FIDE and AICF Laws of Chess.</p>
        <ul class="list-style list-style1 mb-3 list-count">
            <li> System of Play: Swiss System</li>
            <li> Number of Rounds: 6 Rounds</li>
            <li> Time Control: 15 minutes + 5 seconds increment per move
                starting from move one.</li>
            <li> Tie-Break: Standard AICF tie-break systems were applied to resolve equal
                scores.</li>
        </ul>
        <!-- <h5 class="primary-purple"> Key Officials & Organizing Committee</h5>
        <ul class="list-style list-style1 mb-3">
            <li>Tournament Director: Mr. Saddam Hussain (President, KCG DCA)</li>
            <li>Organizing Secretary: Mr. Yatendrajeet Singh (Vice President, KCG DCA)</li>
            <li>Chief Arbiter: IA Rocky Dewangan (Secretary, KCG DCA)</li>
        </ul> -->
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/KCG-tournament-report.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
